export { VpPageTitle } from './VpPageTitle';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPageTitle/index.js